import React from "react";
import { Global } from "@emotion/react";
import { GlobalStyle } from "./GlobalStyle";

const CommonLayout = ({ children }) => {
  return (
    <>
      <Global styles={GlobalStyle} />
      <div
        style={{
          margin: "0 auto",
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >
        <div style={{ flexGrow: 1, overflow: "hidden" }}>{children}</div>
      </div>
    </>
  );
};

export default CommonLayout;
